import { IFormNewUncertainty } from "../../../types/uncertainty.types";
import ATPPForm from "../components/subForms/atPPForm";
import Fe55Uncertainty from "../components/subForms/fe55";
import AAFeNiUncertainty from "../components/subForms/feNi";
import PesadaVolumenForm from "../components/subForms/pesadaVolumenForm";
import PotasioAAForm from "../components/subForms/potasioMedioAA";
import TritioForm from "../components/subForms/tritioForm";

export const setsUncertaintyForm: {
  label: string;
  set: string;
  endpoint: string;
  component: React.ComponentType<any>;
}[] = [
  {
    label: "Pesada y volumen",
    set: "pesada-y-volumen",
    endpoint: "/pesada-y-volumen",
    component: PesadaVolumenForm,
  },
  {
    label: "Tritio",
    set: "tritio",
    endpoint: "/tritio",
    component: TritioForm,
  },
  {
    label: "Alfa Total, Beta Total Resto, Fe55, Ni63",
    set: "fe55",
    endpoint: "/fe55",
    component: Fe55Uncertainty,
  },
  {
    label: "Alfa Total-PP",
    set: "alfa-total-para-pp",
    endpoint: "/alfa-total-para-pp",
    component: ATPPForm,
  },
  {
    label: "Potasio medio por AA",
    set: "potasio-medio-por-aa",
    endpoint: "/potasio-medio-por-aa",
    component: PotasioAAForm,
  },
  {
    label: "AA Fe y Ni",
    set: "FeNI",
    endpoint: "/feNi",
    component: AAFeNiUncertainty,
  },
];

type FieldName = keyof IFormNewUncertainty;

export const requiredFields: FieldName[] = [
  "evh3_d",
  "eumpp",
  "eumps",
  "mass_uncertainty_tertiary_pattern",
  "euvps_btr",
  "eumps_h3",
  "eump_k40",
  "euvps",
  "uncertainty_source_pat_terc",
  "emh3_d",
];
